<div class="qr-dialog">
  <div class="qr-dialog__header">
    <h2 class="qr-dialog__title">{{ data.title || 'QR Code' }}</h2>
    <button
      type="button"
      class="qr-dialog__close"
      (click)="dialogRef.close()"
      matTooltip="Close"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="qr-dialog__content">
    @if (isGenerating) {
      <div class="qr-dialog__loading">Generating QR code...</div>
    } @else if (generateError) {
      <div class="qr-dialog__error">Unable to generate QR code.</div>
    } @else {
      <div class="qr-dialog__qr-wrap">
        <img
          [src]="qrCodeDataUrl"
          alt="Training join QR code"
          class="qr-dialog__qr-image"
        />
      </div>
      <p class="qr-dialog__url" [title]="data.url">{{ data.url }}</p>
    }
  </mat-dialog-content>

  @if (!isGenerating && !generateError) {
    <mat-dialog-actions class="qr-dialog__actions">
      <button
        mat-stroked-button
        type="button"
        class="qr-dialog__action-btn"
        (click)="copyLink()"
      >
        <mat-icon>content_copy</mat-icon>
        Copy Link
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="qr-dialog__action-btn"
        (click)="copyQrCode()"
      >
        <mat-icon>qr_code_2</mat-icon>
        Copy QR Code
      </button>
    </mat-dialog-actions>
  }
</div>
